import UseAgent from '../../utils/userAgent';
import FitImageAdjuster from '../../modules/image/fitImageAdjuster';

const fitImageAdjuster = new FitImageAdjuster();

// // Edgeのみ、縦長画像がぼやけるバグの対策を読み込む
if (UseAgent.isEdge) fitImageAdjuster.init();

// サブ画像がappendされたときも発火させる
const targetParent = document.getElementById('js-add_image');
if (UseAgent.isEdge && targetParent) {
  // appedされたタイミングを監視
  const appendObserver = new MutationObserver(mutations => {
    mutations.forEach(() => {
      fitImageAdjuster.init();
    });
  });
  const observerConfig = { attributes: true, childList: true, characterData: true };
  appendObserver.observe(targetParent, observerConfig);
}
